import cloneDeep from 'lodash/cloneDeep';
import { ActionTypes } from '../../actions/index';
import { addSeatToCart, disableCart, flexMaxQuantityReachedForAllTickets, flexMaxQuantityReachedForPriceType, flexMinQuantityReached, maxTicketsThresholdReached, removeSeatFromCart, resetflexMinQuantityReached, updateFlexMessaging } from '../../cart/actions/cart-actions';
import { ItemType } from '../../classes/item-type';
import { Level } from '../../classes/level';
import { PriceType } from '../../classes/price-type';
import { CartSeat, Seat, SeatPriceQuantity, SeatPricing, SeatZone } from '../../classes/seat';
import { IAppState } from '../../reducers/index';
import { fetchSeatMap, getSeatViewUrl } from '../actions/seatmap-fetch';

/*
 * action creators
 */
export function toggleSeatmapFilters() {
    return (dispatch, state) => {
        const st = state() as IAppState;

        if (st.seatMapModel.openSeatmapFilters) {
            dispatch(closeSeatmapFilters(true));
        } else {
            dispatch(openSeatmapFilters());
        }
    }
}

export function closeSeatmapFilters(shouldTrack: boolean) {
    return { type: ActionTypes.CLOSE_SEATMAP_FILTERS, unTrackEvent: !shouldTrack };
}

export function openSeatmapFilters() {
    return { type: ActionTypes.OPEN_SEATMAP_FILTERS };
}

export function toggleSeatmapCart() {
    return (dispatch, state) => {
        const st = state() as IAppState;

        if (st.seatMapModel.openSeatmapCart) {
            dispatch(closeSeatmapCart(true));
        } else {
            dispatch(openSeatmapCart(true));
        }
    }
}

export function closeSeatmapCart(shouldTrack: boolean) {
    return { type: ActionTypes.CLOSE_SEATMAP_CART, unTrackEvent: shouldTrack };

}

export function openSeatmapCart(shouldTrack: boolean) {
    return { type: ActionTypes.OPEN_SEATMAP_CART, unTrackEvent: !shouldTrack };
}

export function closeSeatingInfo() {
    return { type: ActionTypes.CLOSE_SEATING_INFO };
}

export function openSeatingInfo() {
    return { type: ActionTypes.OPEN_SEATING_INFO };
}

export function selectPriceTypeQuantities(priceTypeQuantities: Array<SeatPriceQuantity>, isFlex: boolean) {
    return (dispatch, getState) => {
        if (priceTypeQuantities.filter(pq => pq.quantity > 0).length > 0) {
            if (isFlex) {
                // If we have one price type, update the cart message to see if you can purchase
                //if (priceTypeQuantities && priceTypeQuantities.length == 1) {
                const state = getState() as IAppState

                dispatch(updateFlexMessaging(+(priceTypeQuantities.filter(pq => pq.quantity > 0)[0].seatPricing.priceTypeId), state.priceTypesModel.priceTypes));

                //}
            }

            dispatch({ type: ActionTypes.SET_SELECTED_PRICE_QUANTITIES, value: priceTypeQuantities });
        }
    }
}

export function seatmapLoadError() {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.REQUEST_SEATMAP_ERROR, value: true });
    }
}

function seatPricingForSeat(seat: Seat, seatZones: Array<SeatZone>, selectedPriceTypes: Array<PriceType>): Array<SeatPricing> {
    const zonePrice = seatZones.filter(pricing =>
        pricing.zoneId.toString() === seat.tessituraSeat.zoneId);

    //if (showAllPriceTypes)
    //    return zonePrice[0].prices;
    //else {
    const selectedPriceTypeIds = selectedPriceTypes.map(pt => {
        return pt.priceTypeId;
    });
    const selectedPrices = zonePrice[0].prices.filter(price => {
        return selectedPriceTypeIds.indexOf(+price.priceTypeId) >= 0;
    });

    if (selectedPrices.length === 0 && zonePrice[0].prices.length === 1) {
        return zonePrice[0].prices;
    }

    return selectedPrices;
    //}
}

export function selectSingleClickSeat(selectedSeat: Seat, selectedPriceTypes: Array<PriceType>, disableOneClickRemove) {
    return (dispatch, state) => {
        let appState: IAppState = state();

        let seatsInCart = appState.cartModel.seats;
        const seatMatchInCart = seatsInCart.filter(seat => seat.seatId === selectedSeat.seatId);

        // If the seat is in the cart, remove it.
        if (seatMatchInCart.length > 0) {
            if (!disableOneClickRemove) {
                dispatch(removeSeatFromCart(seatMatchInCart[0], selectedPriceTypes, appState.appSettingsModel.brandId, false));
            } else {
                dispatch(selectSeat(selectedSeat, true));
            }
        } else {
            dispatch(selectSeat(selectedSeat, true));
            const priceTypes = seatPricingForSeat(selectedSeat, appState.seatMapModel.allSeatPricing, selectedPriceTypes);
            if (priceTypes.length > 0) {
                checkAndAddSeatToCart(selectedSeat, priceTypes, appState, selectedPriceTypes, dispatch);
            }
        }
    };
}



function checkAndAddSeatToCart(selectedSeat: Seat, priceTypes: SeatPricing[], appState: IAppState, selectedPriceTypes: PriceType[], dispatch: any) {
    let seatWithPrice = cloneDeep(selectedSeat) as CartSeat;
    seatWithPrice.selectedPricing = { ...priceTypes[0] };
    // Otherwise, check if adding to cart is valid.
    const samePriceTypeSeatsInCart = appState.cartModel.seats.filter(cartSeat => cartSeat.selectedPricing.priceTypeId === seatWithPrice.selectedPricing.priceTypeId);
    // Get the max allowed number of seats for the selected price type.
    const samePriceTypeInSelected = selectedPriceTypes.filter(priceType => priceType.priceTypeId === seatWithPrice.selectedPricing.priceTypeId);
    let maxQuantity = Number.MAX_VALUE;
    let hasMaxQuantity = samePriceTypeInSelected.length > 0
        && samePriceTypeInSelected[0].clientMaxQuantity != null && samePriceTypeInSelected[0].clientMaxQuantity > 0;
    if (hasMaxQuantity) {
        maxQuantity = samePriceTypeInSelected[0].clientMaxQuantity;
    }
    let flexPackage: boolean;
    const globalMin = appState.appSettingsModel.minTicketQuantity;

    if (appState.appSettingsModel.itemType === ItemType.Super || appState.appSettingsModel.itemType === ItemType.Flex || globalMin > 0) {
        if (hasMaxQuantity) {
            // Here is the first location we know the price type, so we're gonna use it up update the display
            dispatch(updateFlexMessaging(+(seatWithPrice.selectedPricing.priceTypeId), selectedPriceTypes))
        }
        flexPackage = true;
        const samePriceTypeFlexPackageQuantity = appState.priceTypesModel.priceTypes.filter(pt => pt.priceTypeId === seatWithPrice.selectedPricing.priceTypeId);
        if (samePriceTypeFlexPackageQuantity.length > 0) {
            maxQuantity = samePriceTypeFlexPackageQuantity[0].selectedQuantity;
        }
    }

    const numberOfTicketsInCart = appState.cartModel.seats.length;
    const globalMax = appState.appSettingsModel.maxTicketQuantity;


    if (numberOfTicketsInCart >= globalMax) {
        dispatchMaxQuantityActions(flexPackage, dispatch, seatWithPrice);
    }

    else if (!checkSpecialSeatingSeatLimit(selectedSeat, appState.cartModel.seats)) {
        dispatchMaxQuantityActions(flexPackage, dispatch, seatWithPrice);
    }

    // the selected seat has an unlock criteria and has a limit based on the number of the unlock seat in the cart
    else if (!checkUnlockSeatConditions(selectedSeat, appState.cartModel.seats)) {
        dispatchMaxQuantityActions(flexPackage, dispatch, seatWithPrice);
    }
    // If the max number of seats selected for the current pricetype has not be reached.
    else if (samePriceTypeSeatsInCart.length >= maxQuantity) {
        dispatchMaxQuantityActions(flexPackage, dispatch, seatWithPrice);
    }
    else {
        checkSeatToAdd(selectedSeat, priceTypes, dispatch, seatWithPrice, appState);
        if (appState.appSettingsModel.itemType === ItemType.Super || appState.appSettingsModel.itemType === ItemType.Flex || globalMin > 0) {
            if (hasMaxQuantity) {
                // Here is the first location we know the price type, so we're gonna use it up update the display
                dispatch(updateFlexMessaging(+(seatWithPrice.selectedPricing.priceTypeId), selectedPriceTypes))
            }
        }
    }
}

export function dispatchMaxQuantityActions(flexPackage: boolean, dispatch: any, seatWithPrice: CartSeat) {
    if (flexPackage) {
        dispatch(flexMaxQuantityReachedForPriceType());
        dispatch(flexMaxQuantityReachedForAllTickets());
    }
    else
        dispatch(maxTicketsThresholdReached(true, seatWithPrice.selectedPricing.priceTypeDescription));
}

export function checkUnlockSeatConditions(selectedSeat: Seat, cartSeats: Array<CartSeat>): boolean {
    // the selected seat has an unlock criteria and has a limit based on the number of the unlock seat in the cart
    if (selectedSeat.seatingOptionGroup != null && selectedSeat.seatingOptionGroup.unlockSeatingOptionGroupId !== null && selectedSeat.seatingOptionGroup.seatLimitPerUnlockSeat > 0) {
        var unlockCriteriaSeatsInCart = cartSeats.filter(cartSeat => cartSeat.seatingOptionGroup.id === selectedSeat.seatingOptionGroup.unlockSeatingOptionGroupId);
        var sameUnlockCriteriaSeatsInCart = cartSeats.filter(cartSeat => cartSeat.seatingOptionGroup.unlockSeatingOptionGroupId !== null
            && cartSeat.seatingOptionGroup.unlockSeatingOptionGroupId === selectedSeat.seatingOptionGroup.unlockSeatingOptionGroupId);
        if (sameUnlockCriteriaSeatsInCart.length < (unlockCriteriaSeatsInCart.length * selectedSeat.seatingOptionGroup.seatLimitPerUnlockSeat)) {
            return true;
        }
        return false;
    }
    return true;
}

export function checkSpecialSeatingSeatLimit(selectedSeat: Seat, cartSeats: Array<CartSeat>): boolean {
    // the selected seat has an unlock criteria and has a limit based on the number of the unlock seat in the cart
    if (selectedSeat.seatingOptionGroup != null && selectedSeat.seatingOptionGroup.seatLimit > 0) {
        var sameSpecialSeatingInCart = cartSeats.filter(cartSeat => cartSeat.seatingOptionGroup !== null
            && cartSeat.seatingOptionGroup.id === selectedSeat.seatingOptionGroup.id);

        if (sameSpecialSeatingInCart.length < selectedSeat.seatingOptionGroup.seatLimit) {
            return true;
        }
        return false;
    }
    return true;
}

function checkSeatToAdd(seatToAdd: Seat, priceTypes: SeatPricing[], dispatch: any, seatWithPrice: CartSeat, appState: IAppState) {
    // If the seat is available, and there is no confirm prompt, add the seat to cart.
    if (seatToAdd.tessituraSeat.isAvailable && !seatToAdd.tessituraSeat.isDisabled) {
        // If there is no confirm prompt.
        if (!seatToAdd.seatStyleCulture.confirmPrompt && priceTypes.length === 1) {
            let cart = document.getElementById('cartIcon');
            if (cart != null) {
                cart.classList.remove('grow');
            }
            dispatch(addSeatToCart(seatWithPrice,
                appState.appSettingsModel.priceTypeSettings,
                appState.appSettingsModel.useOnlyPromoPriceType,
                appState.exchangeSettingsModel.activeExchangeTickets,
                appState.exchangeSettingsModel.exchangeTickets));
        }
    }
}

export function selectSeat(seat: Seat, shouldOpenSeatingInfo: boolean) {
    return (dispatch, state) => {
        if (state().seatMapModel.openSeatmapFilters) {
            dispatch(closeSeatmapFilters(false))
        }

        dispatch({ type: ActionTypes.SELECT_SEAT, value: { seats: [seat], openInfo: shouldOpenSeatingInfo } });
    };
}

export function selectGroupedSeats(seats: Array<Seat>, seatMapId: string, shouldFetchSeatView: boolean) {
    return (dispatch, state) => {
        if (shouldFetchSeatView) {
            seats[0].seatViewImageSrc = getSeatViewUrl(seats[0].seatViewImageId);
        }

        dispatch({ type: ActionTypes.SELECT_SEAT, value: { seats: seats, openInfo: true } });
    };
}

export function hoverSeatCoordinates(xCoordinate: number, yCoordinate: number, seats: Array<Seat>) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.HOVER_SEAT, value: { xCoord: xCoordinate, yCoord: yCoordinate, seatsHovered: seats } });
    };
}

export function unselectSeat() {
    return { type: ActionTypes.UNSELECT_SEAT };
}

export function selectZoneUpsell() {
    return { type: ActionTypes.SELECT_ZONE_UPSELL };
}

export function resetZoneUpsellCount() {
    return { type: ActionTypes.RESET_ZONE_UPSELL };
}

export function userChangedZoom(newZoom: number, zoomChanged: boolean) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.ON_ZOOM, value: { newZoom, zoomChanged } });
    };
}

//export function selectNextSeat() {
//    return (dispatch, state) => {
//        dispatch({ type: ActionTypes.SELECT_NEXT_SEAT });
//        dispatch({ type: ActionTypes.SET_CURRENT_SEAT_COORD, value: state().seatMapModel.selectedSeat.svgBounds });
//    };
//}

//export function selectPreviousSeat() {
//    return (dispatch, state) => {
//        dispatch({ type: ActionTypes.SELECT_PREVIOUS_SEAT });
//        dispatch({ type: ActionTypes.SET_CURRENT_SEAT_COORD, value: state().seatMapModel.selectedSeat.svgBounds });
//    };
//}

export function selectVenueLevel(level: Level, cartSeats) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.SELECT_LEVEL, value: level.id });
        dispatch(fetchSeatMap(level.seatmap.id, cartSeats, false, []));
    };
}

export function loadInCartStyleForSeat(seat: Seat) {
    return { type: ActionTypes.LOAD_SEAT_INCART_STYLE, value: seat };
}

export function unlockSeats(seats: Array<Seat>) {
    return { type: ActionTypes.UNLOCK_SEATS, value: seats };
}

export function lockSeats(seats: Array<Seat>) {
    return { type: ActionTypes.LOCK_SEATS, value: seats };
}

export function lockAllSeats() {
    return { type: ActionTypes.LOCK_ALL_SEATS };
}